function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#6F7493;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_135",
  transform: "translate(-558.182 -236.791)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-edit",
  transform: "translate(556.182 234.973)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_6"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16.5,20.8H4.7c-1.5,0-2.7-1.2-2.7-2.7V6.3c0-1.5,1.2-2.7,2.7-2.7h5.9c0.6,0,1,0.4,1,1s-0.4,1-1,1H4.7 C4.3,5.6,4,5.9,4,6.3v11.8c0,0.4,0.3,0.7,0.7,0.7h11.8c0.4,0,0.7-0.3,0.7-0.7v-5.9c0-0.6,0.4-1,1-1s1,0.4,1,1v5.9 C19.2,19.6,18,20.8,16.5,20.8z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_7"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M8.1,15.8c-0.3,0-0.5-0.1-0.7-0.3c-0.2-0.2-0.3-0.6-0.3-0.9L8,11.1c0-0.2,0.1-0.3,0.3-0.5l8-8c0,0,0,0,0,0 c1.1-1.1,2.9-1,4,0.1c1,1.1,1,2.8,0,3.9l-8.1,8.1c-0.1,0.1-0.3,0.2-0.5,0.3l-3.4,0.8C8.2,15.8,8.2,15.8,8.1,15.8z M9.8,11.9 l-0.4,1.5L11,13l7.8-7.8c0.3-0.3,0.3-0.8,0-1.1c-0.1-0.2-0.3-0.2-0.6-0.2c-0.2,0-0.4,0.1-0.6,0.2L9.8,11.9z"
}))));

var SvgEdit2 = function SvgEdit2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 19",
    style: {
      enableBackground: "new 0 0 19 19"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit2.2437e378.svg";
export { ForwardRef as ReactComponent };